import { postUrl } from '@/apiCalls/fetch';
import {
    setAttribution,
    setCorrelationId,
    setPartnerOverwriteId,
} from '@/context/borrower';
import { store } from '@/context/store';

import { IInitialApplication } from '../getInitialApplication';

export async function setInitialApplication(
    data: IInitialApplication,
    partnerId: string
): Promise<void> {
    let partnerOverwriteId: string | undefined | null =
        data.paramPartnerOverwriteId;

    // If partner overwrite id is not set, but email is, try fetching the id
    if (!partnerOverwriteId && data.paramIqPartnerEmail) {
        const url = '/api/partner/overwritePartnerId/email';
        partnerOverwriteId = await postUrl<string | undefined>(url, {
            email: data.paramIqPartnerEmail,
            partnerId,
        });
    }

    // If partner overwrite id is still not set, but the partner has an overwrite id, use that
    if (!partnerOverwriteId && data.partnerPartnerOverwriteId) {
        partnerOverwriteId = data.partnerPartnerOverwriteId;
    }

    // Set partner overwrite id to redux
    if (partnerOverwriteId) {
        const currentStateValue =
            store.getState().borrowerReducer.application.partnerOverwriteId;

        if (partnerOverwriteId !== currentStateValue) {
            store.dispatch(setPartnerOverwriteId(partnerOverwriteId));
        }
    }

    // Set correlation id to redux if provided
    if (data.paramCorrelationId) {
        const currentCorrelationId =
            store.getState().borrowerReducer.application.correlationId;

        if (data.paramCorrelationId !== currentCorrelationId) {
            store.dispatch(setCorrelationId(data.paramCorrelationId));
        }
    }

    // Marketing attribution from the landing URL (SR-2784). It rides the borrower
    // slice to the API on the next save, which stores it once. Only the first set
    // of tags is kept: a later navigation without them must not clear what the
    // landing URL gave us, and the API ignores anything after the first write.
    if (data.paramAttribution) {
        const currentAttribution =
            store.getState().borrowerReducer.application.attribution;

        if (!currentAttribution) {
            store.dispatch(setAttribution(data.paramAttribution));
        }
    }
}
